var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDenodoSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9988 23H24.9988V25H22.9988V23ZM15.6328 27.634L17.3648 26.634L18.3648 28.366L16.6328 29.366L15.6328 27.634ZM22.9988 31H24.9988V33H22.9988V31ZM30.6328 26.634L32.3648 27.634L31.3648 29.366L29.6328 28.366L30.6328 26.634ZM29.6328 19.634L31.3648 18.634L32.3648 20.366L30.6328 21.366L29.6328 19.634ZM22.9988 15H24.9988V17H22.9988V15ZM15.6328 20.366L16.6328 18.634L18.3648 19.634L17.3648 21.366L15.6328 20.366Z",
    stroke: "#00D08D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenodoSelected);
export default __webpack_public_path__ + "static/media/Denodo_Selected.eef8632e404c77f54cc5a1e1a2090cbb.svg";
export { ForwardRef as ReactComponent };